<nz-spin [nzSpinning]="loading">
    <form nz-form nz-row [formGroup]="validateForm" class="location-group-container">
        <nz-form-item nz-col [nzSpan]="colSpan">
            <nz-form-label [nzSpan]="labelSpan">{{ hasLocationText ? 'Location ' : ''}}LAB</nz-form-label>
            <nz-form-control [nzSpan]="24 - labelSpan">
                <nz-select nzShowSearch
                           [nzDisabled]="!canEdit"
                           [nzAllowClear]="true"
                           nzPlaceHolder="Please select"
                           (ngModelChange)="changeLab()"
                           formControlName="locationLabId">
                    <nz-option *ngFor="let item of labOptions" [nzLabel]="item.label" [nzValue]="item.value"></nz-option>
                </nz-select>
            </nz-form-control>
        </nz-form-item>
        <nz-form-item nz-col [nzSpan]="colSpan">
            <nz-form-label [nzSpan]="labelSpan">{{ hasLocationText ? 'Location ' : ''}}Floor</nz-form-label>
            <nz-form-control [nzSpan]="24 - labelSpan">
                <nz-select (ngModelChange)="changeFloor()" [nzDisabled]="!canEdit" [nzLoading]="selectFloorLoading" nzShowSearch [nzAllowClear]="true" nzPlaceHolder="Please select" formControlName="locationFloorId">
                    <nz-option *ngFor="let item of floorOptions" [nzLabel]="item.label" [nzValue]="item.value"></nz-option>
                </nz-select>
            </nz-form-control>
        </nz-form-item>
        <nz-form-item nz-col [nzSpan]="colSpan">
            <nz-form-label [nzSpan]="labelSpan">{{ hasLocationText ? 'Location ' : ''}}Room</nz-form-label>
            <nz-form-control [nzSpan]="24 - labelSpan">
                <nz-select (ngModelChange)="changeRoom()" [nzDisabled]="!canEdit" [nzLoading]="selectRoomLoading" nzShowSearch [nzAllowClear]="true" nzPlaceHolder="Please select" formControlName="locationRoomId">
                    <nz-option *ngFor="let item of roomOptions" [nzLabel]="item.label" [nzValue]="item.value"></nz-option>
                </nz-select>
            </nz-form-control>
        </nz-form-item>
        <nz-form-item nz-col [nzSpan]="colSpan">
            <nz-form-label [nzSpan]="labelSpan">Room Storage Template</nz-form-label>
            <nz-form-control [nzSpan]="24 - labelSpan">
                <nz-select (ngModelChange)="changeType()" nzShowSearch [nzDisabled]="!canEdit" [nzAllowClear]="true" nzPlaceHolder="Please select" formControlName="locationTypeId">
                    <nz-option *ngFor="let item of locationTypeOptions" [nzLabel]="item.label" [nzValue]="item.value"></nz-option>
                </nz-select>
            </nz-form-control>
        </nz-form-item>
        <nz-form-item nz-col [nzSpan]="colSpan">
            <nz-form-label [nzSpan]="labelSpan">Location</nz-form-label>
            <nz-form-control [nzSpan]="24 - labelSpan">
                <nz-cascader
                    [nzDisabled]="!canEdit"
                    formControlName="locationIds"
                    [nzExpandTrigger]="'hover'"
                    [nzOptions]="locationOptions"
                    [nzChangeOnSelect]="true"
                ></nz-cascader>
            </nz-form-control>
        </nz-form-item>
    </form>
</nz-spin>
